export default "__VITE_ASSET__BMvzt8Ah__"